export default __webpack_public_path__ + "static/12-ec51fc181d51168e9c5025e828e51c0f.png";